<template>
  <div class="log-oppea-box">
    <!-- 顶部信息区域 -->
    <div class="header-info">
      <div class="info-item">操作用户：{{rowItem.operatedUserPO && rowItem.operatedUserPO.realName}}</div>
      <div class="info-item">被操作对象：{{form && form.updateTag}}</div>
      <div class="info-item">修改时间：{{rowItem.operatedTime}}</div>
    </div>

    <!-- 对比内容区域 -->
    <el-row v-if="form" class="compare-container">
      <el-col :span="12" v-if="form.beforeStr">
        <div class="compare-card before-card">
          <div class="card-title">变更前</div>
          <div class="card-content">
            <div class="content-item">角色名称：{{form.beforeStr.role && form.beforeStr.role.role_name}}</div>
            <div class="content-item">角色编码：{{form.beforeStr.role && form.beforeStr.role.code}}</div>
            <div class="content-item">备注：{{form.beforeStr.role && form.beforeStr.role.remark}}</div>
            <div class="content-item">状态：{{form.beforeStr.role && form.beforeStr.role.role_status?'启用':'禁用'}}</div>
            <div class="content-item">
              <span class="label">菜单：</span>
              <div class="tag-list">
                <span class="tag" :class="{ 'changed': isMenuChanged(item.menu_name, 'before') }" v-for="(item,index) in getUniqueMenus(form.beforeStr.roleMenuList)" :key="index">
                  {{item.menu_name}}
                </span>
              </div>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :span="12" v-if="form.afterStr">
        <div class="compare-card after-card">
          <div class="card-title">变更后</div>
          <div class="card-content">
            <div class="content-item">角色名称：{{form.afterStr.role && form.afterStr.role.role_name}}</div>
            <div class="content-item">角色编码：{{form.afterStr.role && form.afterStr.role.code}}</div>
            <div class="content-item">备注：{{form.afterStr.role && form.afterStr.role.remark}}</div>
            <div class="content-item">状态：{{form.afterStr.role && form.afterStr.role.role_status?'启用':'禁用'}}</div>
            <div class="content-item">
              <span class="label">菜单：</span>
              <div class="tag-list">
                <span class="tag" :class="{ 'changed': isMenuChanged(item.menu_name, 'after') }" v-for="(item,index) in getUniqueMenus(form.afterStr.roleMenuList)" :key="index">
                  {{item.menu_name}}
                </span>
              </div>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import sysDataCompareLogApi from '@/api/log/sysDataCompareLog'
export default {
  props: ['rowItem'],
  data() {
    return {
      form: null,
      sectionList: []
    }
  },
  async created() {
    this.getLogShow()
  },
  methods: {
    getLogShow() {
      sysDataCompareLogApi.fetchById(this.rowItem.id).then(res => {
        this.form = res.data;
      })
    },
    // 获取去重后的菜单列表
    getUniqueMenus(menuList) {
      if (!menuList || !Array.isArray(menuList)) return [];

      const uniqueMenus = [];
      const seenNames = new Set();

      menuList.forEach(item => {
        if (item && item.menu_name && !seenNames.has(item.menu_name)) {
          seenNames.add(item.menu_name);
          uniqueMenus.push(item);
        }
      });

      return uniqueMenus;
    },
    // 检查菜单是否发生变化（更新为使用去重后的数据）
    isMenuChanged(menuName, side) {
      if (!this.form || !this.form.beforeStr || !this.form.afterStr) return false;

      const beforeMenus = this.getUniqueMenus(this.form.beforeStr.roleMenuList);
      const afterMenus = this.getUniqueMenus(this.form.afterStr.roleMenuList);

      if (side === 'before') {
        // 删除的菜单 - 在变更前存在，变更后不存在
        const isDeleted = !afterMenus.some(item => item.menu_name === menuName);
        return isDeleted;
      } else {
        // 新增的菜单 - 在变更后存在，变更前不存在
        const isAdded = !beforeMenus.some(item => item.menu_name === menuName);
        return isAdded;
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.log-oppea-box {
  background: #f5f7fa;
  padding: 20px;
  border-radius: 8px;
  min-height: 100vh;
}

.header-info {
  background: white;
  padding: 16px 20px;
  border-radius: 6px;
  margin-bottom: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);

  .info-item {
    font-size: 14px;
    color: #606266;
    line-height: 1.8;

    &:not(:last-child) {
      margin-bottom: 8px;
    }
  }
}

.compare-container {
  gap: 20px;
}

.compare-card {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  height: 100%;

  &.before-card {
    border-left: 4px solid #e6a23c;
  }

  &.after-card {
    border-left: 4px solid #67c23a;
  }
}

.card-title {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 12px 20px;
  font-size: 16px;
  font-weight: 600;
  text-align: center;
}

.card-content {
  padding: 20px;
}

.content-item {
  margin-bottom: 16px;
  font-size: 14px;
  line-height: 1.6;

  &:last-child {
    margin-bottom: 0;
  }

  .label {
    color: #606266;
    font-weight: 500;
    display: inline-block;
    min-width: 60px;
  }
}

// ... existing code ...
.tag-list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 8px;

  .tag {
    background: #f0f2f5;
    color: #606266;
    padding: 4px 12px;
    border-radius: 16px;
    font-size: 12px;
    border: 1px solid #e4e7ed;
    transition: all 0.3s ease;
    position: relative;

    &:hover {
      background: #e6f7ff;
      border-color: #91d5ff;
      color: #1890ff;
    }

    // 变化标记样式
    &.changed {
      font-weight: 500;

      // 变更前（删除的项目）- 红色
      .before-card & {
        background: #fff2f0;
        color: #f5222d;
        border-color: #ffccc7;

        &:hover {
          background: #fff1f0;
          border-color: #ff7875;
        }

        // 添加删除线效果
        &::before {
          content: '';
          position: absolute;
          top: 50%;
          left: 0;
          right: 0;
          height: 1px;
          background: #f5222d;
          transform: translateY(-50%);
          opacity: 0.6;
        }
      }

      // 变更后（新增的项目）- 绿色
      .after-card & {
        background: #f6ffed;
        color: #52c41a;
        border-color: #b7eb8f;

        &:hover {
          background: #f0f9ff;
          border-color: #95de64;
        }

        // 添加新增标记
        &::after {
          content: '+';
          position: absolute;
          top: -2px;
          right: -2px;
          width: 16px;
          height: 16px;
          background: #52c41a;
          color: white;
          border-radius: 50%;
          font-size: 10px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: bold;
        }
      }
    }
  }
}

// 响应式设计
@media (max-width: 768px) {
  .compare-container {
    .el-col {
      margin-bottom: 20px;
    }
  }

  .tag-list {
    .tag {
      font-size: 11px;
      padding: 3px 8px;
    }
  }
}

// 动画效果
.compare-card {
  transition: transform 0.3s ease, box-shadow 0.3s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  }
}

// 加载状态
.log-oppea-box {
  &.loading {
    opacity: 0.7;
    pointer-events: none;
  }
}
</style>